import { useState, useEffect } from 'react';
import { Button, Input, Modal } from 'semantic-ui-react';
import authServiceInstance from '../../services/api/auth';
import { useRecaptchaToken, isCaptchaRequired, RECAPTCHA_SECURITY_ERROR } from './recaptchaUtils';
import { RegistrationForm } from 'src/assets/styles/components/Registration';

const ExpressLogin = (props) => {
  const [inputs, setInputs] = useState({});
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorData, set_errorData] = useState(null);
  const getCaptchaToken = useRecaptchaToken('login');

  useEffect(() => {
    setInputs({ email: props.email });
  }, [props.email]);

  const handleInputs = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    setInputs({ ...inputs, [name]: value });
  };

  async function login(e) {
    e.preventDefault();
    const { email, password } = inputs;

    if (!email || !password) {
      set_errorData('Todos los campos son obligatorios');
      return;
    }

    setLoading(true);
    try {
      const captchaRequired = isCaptchaRequired();
      const captcha = await getCaptchaToken({ skip: !captchaRequired });
      if (captchaRequired && !captcha) {
        set_errorData(RECAPTCHA_SECURITY_ERROR);
        setLoading(false);
        return;
      }

      const response = await authServiceInstance.login({ email, password, captcha }, false);
      setLoading(false);
      if (response.data.success) {
        setOpen(false);
        props?.onSuccessLogin?.();
        localStorage.setItem('userToken', response.data.token);
      }
    } catch (error) {
      if (error.response) set_errorData(error.response.data.message);
      setLoading(false);
    }
  }

  return (
    <Modal
      onClose={() => setOpen(false)}
      closeIcon
      onOpen={() => setOpen(true)}
      open={open}
      trigger={
        <Button basic color="black">
          Iniciar sesión
        </Button>
      }
    >
      <Modal.Header>Iniciar sesión</Modal.Header>
      <RegistrationForm onSubmit={(e) => login(e)}>
        <p style={{ margin: 0 }}>
          Escribe {!props.email && 'el usuario y'} la contraseña {!!props.email && 'de'}{' '}
          {props.email} para continuar:
        </p>
        <div style={{ margin: '20px auto' }}>
          {!props.email && (
            <Input
              placeholder="Usuario"
              onChange={handleInputs}
              name={'email'}
              value={inputs.email}
              type="email"
            />
          )}
          <Input
            placeholder="Contraseña"
            onChange={handleInputs}
            name={'password'}
            value={inputs.password}
            type="password"
          />
          {errorData && (
            <label style={{ display: 'block', padding: '20px 0', color: 'red' }}>{errorData}</label>
          )}
        </div>
        <Button disabled={loading} type="submit">
          Entrar
        </Button>
      </RegistrationForm>
    </Modal>
  );
};

export default ExpressLogin;
